// The board's shared timer, stored on the page so everyone (and plugins) sees the same one.
import type { NodeData } from '@vellum/core';
import { app } from './app.ts';

export interface TimerState {
  state: 'STOPPED' | 'RUNNING' | 'PAUSED';
  /** seconds left, and the length it was started with */
  remaining: number;
  total: number;
}

export function timerOf(page: NodeData | undefined, now = Date.now()): TimerState {
  const d = page?.pluginData ?? {};
  const end = Number(d.timerEnd || 0),
    paused = Number(d.timerPaused || 0),
    total = Number(d.timerTotal || 0) / 1000;
  if (paused) return { state: 'PAUSED', remaining: paused / 1000, total: total || paused / 1000 };
  if (end) return { state: 'RUNNING', remaining: Math.max(0, end - now) / 1000, total: total || Math.max(0, end - now) / 1000 };
  return { state: 'STOPPED', remaining: 0, total: 0 };
}

export function timerAction(action: 'start' | 'pause' | 'resume' | 'stop' | 'add', seconds = 0) {
  const page = app.doc.get(app.editor.pageId);
  if (!page) return;
  const t = timerOf(page);
  const d = { ...(page.pluginData ?? {}) };
  const set = (end: number, pausedMs: number, totalMs: number) => {
    d.timerEnd = end ? String(end) : '';
    d.timerPaused = pausedMs ? String(Math.round(pausedMs)) : '';
    d.timerTotal = totalMs ? String(Math.round(totalMs)) : '';
  };
  if (action === 'start') set(Date.now() + seconds * 1000, 0, seconds * 1000);
  else if (action === 'pause' && t.state === 'RUNNING') set(0, t.remaining * 1000, t.total * 1000);
  else if (action === 'resume' && t.state === 'PAUSED') set(Date.now() + t.remaining * 1000, 0, t.total * 1000);
  else if (action === 'add') set(Date.now() + (t.state === 'STOPPED' ? 0 : t.remaining * 1000) + seconds * 1000, 0, t.total * 1000 + seconds * 1000);
  else if (action === 'stop') set(0, 0, 0);
  else return;
  app.editor.update(page.id, { pluginData: d }, action === 'start' ? 'Start timer' : action === 'stop' ? 'Stop timer' : 'Timer');
}
